import { useEffect, useState } from 'react';
import { SocketConnection } from '../socket-main-thread/socket-connection';
import { ConnectedAdmin, IBreakoutRoomProfile } from '@/types/profile.types';
import manager from '../socket-main-thread/socket-manager';
import { SocketMessage } from '../socket-main-thread/types';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export default interface Socket extends SocketConnection {
  // Must use SocketManager to get a new socket connection.
  // using new Socket() is deprecated in components
}

const baseConnection = new SocketConnection('');

export function useSocket(channel: string, admin?: ConnectedAdmin, profile?: IBreakoutRoomProfile): Socket {
  const [socket, setSocket] = useState<Socket>(baseConnection);

  useEffect(() => {
    if (channel.includes('undefined')) {
      console.warn('Skipping ws channel', channel, 'because it includes "undefined"');
      return;
    }

    setSocket(manager.getFromHook(channel, { admin, profile }));

    return () => {
      manager.leave(channel);
    };
  }, [admin, channel, profile]);

  return socket;
}

export type { SocketMessage };
